module.exports = __webpack_public_path__ + "static/media/splash-brisa.19ed7d5f.png";